export const openModal = async (
	component: Component,
	componentProps?: Record<string, unknown>,
	presentingElement?: HTMLElement,
	ariaLabel?: string,
) => {
	const modal = await modalController.create({
		component,
		componentProps,
		presentingElement,
		...(ariaLabel && { htmlAttributes: { 'aria-label': ariaLabel } }),
	})
	await modal.present()
	await modal.onDidDismiss()
}
